import ApplicationAdapter from './application';

export default class NcesSchoolAdapter extends ApplicationAdapter {
  query(store, type, query) {
    let baseUrl = this.buildURL(type.modelName, null, null, 'query', query);
    return this.ajax(`${baseUrl}/query`, 'POST', { data: query });
  }
}
